import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { ArrowLeft, Briefcase, Mail, Calendar } from 'lucide-react';
interface Brand {
  id: string;
  name: string;
  logo?: string;
  status: 'active' | 'completed';
  campaigns: number;
  lastCollaboration: string;
  contactPerson: {
    name: string;
    email: string;
  };
}
const mockBrands: Brand[] = [{
  id: '1',
  name: 'Nike',
  status: 'active',
  campaigns: 2,
  lastCollaboration: '2024-06-01',
  contactPerson: {
    name: 'John Smith',
    email: 'john@nike.com'
  }
}, {
  id: '2',
  name: 'Adidas',
  status: 'active',
  campaigns: 1,
  lastCollaboration: '2024-05-15',
  contactPerson: {
    name: 'Sarah Johnson',
    email: 'sarah@adidas.com'
  }
}, {
  id: '3',
  name: 'Red Bull',
  status: 'completed',
  campaigns: 1,
  lastCollaboration: '2024-04-20',
  contactPerson: {
    name: 'Mike Chen',
    email: 'mike@redbull.com'
  }
}];
export function CreatorBrandsPage() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gray-50 pb-12" data-id="element-486">
      <header className="bg-white border-b sticky top-0 z-10" data-id="element-487">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-488">
          <div className="flex items-center" data-id="element-489">
            <Button variant="ghost" size="sm" className="mr-4" onClick={() => navigate('/creator')} data-id="element-490">
              <ArrowLeft className="h-4 w-4 mr-2" data-id="element-491" /> Back
            </Button>
            <h1 className="text-xl font-bold text-gray-900" data-id="element-492">My Brands</h1>
          </div>
        </div>

        {/* Tabs */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-493">
          <div className="flex space-x-8 -mb-px" data-id="element-494">
            <button onClick={() => navigate('/creator')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-495">
              Dashboard
            </button>
            <button onClick={() => navigate('/creator/campaigns')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-496">
              Campaigns
            </button>
            <button onClick={() => navigate('/creator/deliverables')} className="pb-4 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300 border-b-2 border-transparent" data-id="element-497">
              Deliverables
            </button>
            <button className="pb-4 text-sm font-medium text-blue-600 border-b-2 border-blue-600" data-id="element-498">
              Brands
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-499">
        <div className="mb-8" data-id="element-500">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-501">
            Brand Partnerships
          </h2>
          <p className="text-gray-500" data-id="element-502">Brands you've collaborated with</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-503">
          {mockBrands.map(brand => <Card key={brand.id} className="hover:shadow-md transition-shadow" data-id="element-504">
              <CardContent className="p-6" data-id="element-505">
                <div className="flex items-start justify-between mb-4" data-id="element-506">
                  <div className="h-12 w-12 bg-gray-100 rounded-full flex items-center justify-center" data-id="element-507">
                    <Briefcase className="h-6 w-6 text-gray-400" data-id="element-508" />
                  </div>
                  <Badge variant={brand.status === 'active' ? 'success' : 'secondary'} className="capitalize" data-id="element-509">
                    {brand.status}
                  </Badge>
                </div>

                <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-510">
                  {brand.name}
                </h3>
                <p className="text-sm text-gray-500 mb-4" data-id="element-511">
                  {brand.campaigns} campaign{brand.campaigns > 1 ? 's' : ''}
                </p>

                <div className="space-y-3 mb-4" data-id="element-512">
                  <div className="flex items-center text-sm text-gray-600" data-id="element-513">
                    <Calendar className="h-4 w-4 mr-2 text-gray-400" data-id="element-514" />
                    <span data-id="element-515">Last: {brand.lastCollaboration}</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-600" data-id="element-516">
                    <Mail className="h-4 w-4 mr-2 text-gray-400" data-id="element-517" />
                    <div className="flex flex-col" data-id="element-518">
                      <span className="font-medium" data-id="element-519">
                        {brand.contactPerson.name}
                      </span>
                      <a href={`mailto:${brand.contactPerson.email}`} className="text-blue-600 hover:underline text-xs" data-id="element-520">
                        {brand.contactPerson.email}
                      </a>
                    </div>
                  </div>
                </div>

                <Button variant="secondary" size="sm" className="w-full" data-id="element-521">
                  View Campaigns
                </Button>
              </CardContent>
            </Card>)}
        </div>
      </main>
    </div>;
}